import { isEmpty } from 'lodash'

export const updatedItemsWithDefaultSelectedItem = (
  itemsArray,
  defaultSelectedItem,
  modifierGroupId
) => {
  const itemsArrauUuid = itemsArray.map((item) => item.uuid)
  const removedItemsFromDefaultSelectedItem =
    defaultSelectedItem.filter(
      (item) => !itemsArrauUuid.includes(item.uuid)
    )

  if (isEmpty(itemsArray)) {
    return defaultSelectedItem
  }

  const updatedItemsArray = itemsArray.reduce((res, cur) => {
    if (cur.uuid === defaultSelectedItem[0]?.uuid) {
      return [
        ...res,
        {
          ...cur,
          itemCategoryExternalRefIds: [
            ...cur.itemCategoryExternalRefIds,
            modifierGroupId,
          ],
          itemCategoryPreferences: {
            ...cur.itemCategoryPreferences,
            [modifierGroupId]:
              defaultSelectedItem[0]?.itemCategoryPreferences[
                modifierGroupId
              ],
          },
        },
      ]
    }
    return [...res, cur]
  }, [])

  return [
    ...removedItemsFromDefaultSelectedItem,
    ...updatedItemsArray,
  ]
}
